module.exports = __webpack_public_path__ + "fonts/8dc137f.ttf";